<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    version="1.1"
    width="500"
    height="500"
    viewBox="0 0 500 500"
    xml:space="preserve"
  >
    <!-- Created with SVG Stack Editor - https://svgstack.com -->
    <defs></defs>
    <rect x="0" y="0" width="100%" height="100%" fill="transparent" />
    <g transform="matrix(4.95 0 0 4.95 250 250)">
      <g style="">
        <g transform="matrix(1 0 0 1 0 6.9)" id="path_0">
          <path
            style="
              stroke: none;
              stroke-width: 1;
              stroke-dasharray: none;
              stroke-linecap: butt;
              stroke-dashoffset: 0;
              stroke-linejoin: miter;
              stroke-miterlimit: 4;
              fill: var(--color-text-secondary);
              fill-rule: nonzero;
              opacity: 1;
            "
            transform=" translate(-50, -56.78)"
            d="M 99.014 41.0887 C 98.7428 40.8733 96.211 38.9616 90.8716 38.9616 C 89.4617 38.9678 88.0548 39.0887 86.6646 39.3232 C 85.6312 32.2401 79.7751 28.7867 79.5125 28.6318 L 78.0788 27.8049 L 77.1358 29.1657 C 75.9549 30.9936 75.0928 33.0086 74.5867 35.125 C 73.6307 39.1683 74.2121 42.966 76.266 46.2127 C 73.7858 47.5948 69.8072 47.9351 69.002 47.9651 L 3.13051 47.9651 C 1.40996 47.9675 0.0138216 49.3579 0.00444499 51.0783 C -0.0723876 56.849 0.905303 62.5853 2.88937 68.0047 C 5.15852 73.9555 8.5344 78.3389 12.9264 81.0215 C 17.8481 84.0356 25.8441 85.7579 34.908 85.7579 C 39.0026 85.7708 43.0896 85.4002 47.1152 84.6513 C 52.7113 83.6238 58.0961 81.6679 63.047 78.8641 C 67.1264 76.5018 70.7979 73.4965 73.9194 69.9639 C 79.1382 64.0562 82.2472 57.4767 84.5593 51.6295 L 85.4807 51.6295 C 91.1946 51.6295 94.7083 49.343 96.6459 47.4269 C 97.9336 46.2049 98.9389 44.7162 99.5912 43.0651 L 100 41.8681 L 99.014 41.0887 Z"
            stroke-linecap="round"
          />
        </g>
        <g transform="matrix(1 0 0 1 -36.35 -8.55)" id="path_1">
          <path
            style="
              stroke: none;
              stroke-width: 1;
              stroke-dasharray: none;
              stroke-linecap: butt;
              stroke-dashoffset: 0;
              stroke-linejoin: miter;
              stroke-miterlimit: 4;
              fill: var(--color-text-secondary);
              fill-rule: nonzero;
              opacity: 1;
            "
            transform=" translate(-13.65, -41.33)"
            d="M 9.23622 46.0362 L 18.0633 46.0362 C 18.489 46.0362 18.834 45.6911 18.834 45.2655 L 18.834 37.4028 C 18.8364 36.9771 18.4932 36.6302 18.0676 36.6278 C 18.0662 36.6278 18.0647 36.6278 18.0633 36.6278 L 9.23622 36.6278 C 8.81049 36.6278 8.46552 36.9729 8.46552 37.3985 L 8.46552 37.4028 L 8.46552 45.2654 C 8.46552 45.6911 8.81049 46.0362 9.23622 46.0362 Z"
            stroke-linecap="round"
          />
        </g>
        <g transform="matrix(1 0 0 1 -24.19 -8.55)" id="path_2">
          <path
            style="
              stroke: none;
              stroke-width: 1;
              stroke-dasharray: none;
              stroke-linecap: butt;
              stroke-dashoffset: 0;
              stroke-linejoin: miter;
              stroke-miterlimit: 4;
              fill: var(--color-text-secondary);
              fill-rule: nonzero;
              opacity: 1;
            "
            transform=" translate(-25.81, -41.33)"
            d="M 21.4004 46.0362 L 30.2275 46.0362 C 30.6532 46.0362 30.9982 45.6911 30.9982 45.2655 L 30.9982 37.4028 C 31.0006 36.9771 30.6574 36.6302 30.2317 36.6278 C 30.2303 36.6278 30.2288 36.6278 30.2274 36.6278 L 21.4003 36.6278 C 20.9722 36.6278 20.6252 36.9747 20.6252 37.4028 L 20.6252 45.2654 C 20.6278 45.6918 20.974 46.0362 21.4004 46.0362 Z"
            stroke-linecap="round"
          />
        </g>
        <g transform="matrix(1 0 0 1 -11.84 -8.55)" id="path_3">
          <path
            style="
              stroke: none;
              stroke-width: 1;
              stroke-dasharray: none;
              stroke-linecap: butt;
              stroke-dashoffset: 0;
              stroke-linejoin: miter;
              stroke-miterlimit: 4;
              fill: var(--color-text-secondary);
              fill-rule: nonzero;
              opacity: 1;
            "
            transform=" translate(-38.16, -41.33)"
            d="M 33.7496 46.0362 L 42.5767 46.0362 C 43.0024 46.0362 43.3474 45.6911 43.3474 45.2655 L 43.3474 37.4028 C 43.3498 36.9771 43.0066 36.6302 42.5809 36.6278 C 42.5795 36.6278 42.5779 36.6278 42.5765 36.6278 L 33.7495 36.6278 C 33.3237 36.6278 32.9788 36.9729 32.9788 37.3985 L 32.9788 37.4028 L 32.9788 45.2654 C 32.9789 45.6911 33.324 46.0362 33.7496 46.0362 Z"
            stroke-linecap="round"
          />
        </g>
        <g transform="matrix(1 0 0 1 0.37 -8.55)" id="path_4">
          <path
            style="
              stroke: none;
              stroke-width: 1;
              stroke-dasharray: none;
              stroke-linecap: butt;
              stroke-dashoffset: 0;
              stroke-linejoin: miter;
              stroke-miterlimit: 4;
              fill: var(--color-text-secondary);
              fill-rule: nonzero;
              opacity: 1;
            "
            transform=" translate(-50.37, -41.33)"
            d="M 45.9525 46.0362 L 54.7796 46.0362 C 55.206 46.0362 55.5523 45.6919 55.5546 45.2655 L 55.5546 37.4028 C 55.5546 36.9747 55.2077 36.6278 54.7796 36.6278 L 45.9525 36.6278 C 45.5268 36.6278 45.1818 36.9729 45.1818 37.3985 L 45.1818 37.4028 L 45.1818 45.2654 C 45.1818 45.6911 45.5269 46.0362 45.9525 46.0362 Z"
            stroke-linecap="round"
          />
        </g>
        <g transform="matrix(1 0 0 1 -24.19 -19.86)" id="path_5">
          <path
            style="
              stroke: none;
              stroke-width: 1;
              stroke-dasharray: none;
              stroke-linecap: butt;
              stroke-dashoffset: 0;
              stroke-linejoin: miter;
              stroke-miterlimit: 4;
              fill: var(--color-text-secondary);
              fill-rule: nonzero;
              opacity: 1;
            "
            transform=" translate(-25.81, -30.02)"
            d="M 21.4004 34.7247 L 30.2275 34.7247 C 30.6538 34.7223 30.9982 34.3759 30.9982 33.9496 L 30.9982 26.0871 C 30.9982 25.6614 30.6531 25.3164 30.2275 25.3164 L 21.4004 25.3164 C 20.9741 25.3164 20.6277 25.6607 20.6254 26.0871 L 20.6254 33.9496 C 20.6277 34.3768 20.9733 34.7223 21.4004 34.7247 Z"
            stroke-linecap="round"
          />
        </g>
        <g transform="matrix(1 0 0 1 -11.84 -19.86)" id="path_6">
          <path
            style="
              stroke: none;
              stroke-width: 1;
              stroke-dasharray: none;
              stroke-linecap: butt;
              stroke-dashoffset: 0;
              stroke-linejoin: miter;
              stroke-miterlimit: 4;
              fill: var(--color-text-secondary);
              fill-rule: nonzero;
              opacity: 1;
            "
            transform=" translate(-38.16, -30.02)"
            d="M 33.7496 34.7247 L 42.5767 34.7247 C 43.0029 34.7223 43.3474 34.3759 43.3474 33.9496 L 43.3474 26.0871 C 43.3474 25.6614 43.0022 25.3164 42.5767 25.3164 L 33.7496 25.3164 C 33.3239 25.3164 32.9789 25.6615 32.9789 26.0871 L 32.9789 33.9496 C 32.9789 34.3759 33.3233 34.7223 33.7496 34.7247 Z"
            stroke-linecap="round"
          />
        </g>
        <g transform="matrix(1 0 0 1 0.37 -19.86)" id="path_7">
          <path
            style="
              stroke: none;
              stroke-width: 1;
              stroke-dasharray: none;
              stroke-linecap: butt;
              stroke-dashoffset: 0;
              stroke-linejoin: miter;
              stroke-miterlimit: 4;
              fill: var(--color-text-secondary);
              fill-rule: nonzero;
              opacity: 1;
            "
            transform=" translate(-50.37, -30.02)"
            d="M 45.9525 34.7247 L 54.7796 34.7247 C 55.2067 34.7223 55.5523 34.3768 55.5546 33.9496 L 55.5546 26.0871 C 55.5523 25.6607 55.206 25.3164 54.7796 25.3164 L 45.9525 25.3164 C 45.5268 25.3164 45.1818 25.6615 45.1818 26.0871 L 45.1818 33.9496 C 45.1818 34.3759 45.5262 34.7223 45.9525 34.7247 Z"
            stroke-linecap="round"
          />
        </g>
        <g transform="matrix(1 0 0 1 0.37 -31.17)" id="path_8">
          <path
            style="
              stroke: none;
              stroke-width: 1;
              stroke-dasharray: none;
              stroke-linecap: butt;
              stroke-dashoffset: 0;
              stroke-linejoin: miter;
              stroke-miterlimit: 4;
              fill: var(--color-text-secondary);
              fill-rule: nonzero;
              opacity: 1;
            "
            transform=" translate(-50.37, -18.7)"
            d="M 45.9525 23.4089 L 54.7796 23.4089 C 55.206 23.4089 55.5523 23.0645 55.5546 22.6382 L 55.5546 14.7712 C 55.5523 14.3448 55.206 14.0005 54.7796 14.0005 L 45.9525 14.0005 C 45.5268 14.0005 45.1818 14.3455 45.1818 14.7712 L 45.1818 22.6381 C 45.1818 23.0638 45.5269 23.4089 45.9525 23.4089 Z"
            stroke-linecap="round"
          />
        </g>
        <g transform="matrix(1 0 0 1 12.68 -8.55)" id="path_9">
          <path
            style="
              stroke: none;
              stroke-width: 1;
              stroke-dasharray: none;
              stroke-linecap: butt;
              stroke-dashoffset: 0;
              stroke-linejoin: miter;
              stroke-miterlimit: 4;
              fill: var(--color-text-secondary);
              fill-rule: nonzero;
              opacity: 1;
            "
            transform=" translate(-62.68, -41.33)"
            d="M 58.2631 46.0362 L 67.0901 46.0362 C 67.5166 46.0362 67.8628 45.6919 67.8652 45.2655 L 67.8652 37.4028 C 67.8652 36.9747 67.5182 36.6278 67.0901 36.6278 L 58.2631 36.6278 C 57.8375 36.6278 57.4924 36.9729 57.4924 37.3985 L 57.4924 37.4028 L 57.4924 45.2654 C 57.4924 45.6911 57.8375 46.0362 58.2631 46.0362 Z"
            stroke-linecap="round"
          />
        </g>
      </g>
    </g>
    <g transform="matrix(4.95 0 0 4.95 250 250)">
      <g style="">
        <g transform="matrix(1 0 0 1 0 6.9)" id="path_0">
          <path
            style="
              stroke: none;
              stroke-width: 1;
              stroke-dasharray: none;
              stroke-linecap: butt;
              stroke-dashoffset: 0;
              stroke-linejoin: miter;
              stroke-miterlimit: 4;
              fill: var(--color-text-secondary);
              fill-rule: nonzero;
              opacity: 1;
            "
            transform=" translate(-50, -56.78)"
            d="M 99.014 41.0887 C 98.7428 40.8733 96.211 38.9616 90.8716 38.9616 C 89.4617 38.9678 88.0548 39.0887 86.6646 39.3232 C 85.6312 32.2401 79.7751 28.7867 79.5125 28.6318 L 78.0788 27.8049 L 77.1358 29.1657 C 75.9549 30.9936 75.0928 33.0086 74.5867 35.125 C 73.6307 39.1683 74.2121 42.966 76.266 46.2127 C 73.7858 47.5948 69.8072 47.9351 69.002 47.9651 L 3.13051 47.9651 C 1.40996 47.9675 0.0138216 49.3579 0.00444499 51.0783 C -0.0723876 56.849 0.905303 62.5853 2.88937 68.0047 C 5.15852 73.9555 8.5344 78.3389 12.9264 81.0215 C 17.8481 84.0356 25.8441 85.7579 34.908 85.7579 C 39.0026 85.7708 43.0896 85.4002 47.1152 84.6513 C 52.7113 83.6238 58.0961 81.6679 63.047 78.8641 C 67.1264 76.5018 70.7979 73.4965 73.9194 69.9639 C 79.1382 64.0562 82.2472 57.4767 84.5593 51.6295 L 85.4807 51.6295 C 91.1946 51.6295 94.7083 49.343 96.6459 47.4269 C 97.9336 46.2049 98.9389 44.7162 99.5912 43.0651 L 100 41.8681 L 99.014 41.0887 Z"
            stroke-linecap="round"
          />
        </g>
        <g transform="matrix(1 0 0 1 -36.35 -8.55)" id="path_1">
          <path
            style="
              stroke: none;
              stroke-width: 1;
              stroke-dasharray: none;
              stroke-linecap: butt;
              stroke-dashoffset: 0;
              stroke-linejoin: miter;
              stroke-miterlimit: 4;
              fill: var(--color-text-secondary);
              fill-rule: nonzero;
              opacity: 1;
            "
            transform=" translate(-13.65, -41.33)"
            d="M 9.23622 46.0362 L 18.0633 46.0362 C 18.489 46.0362 18.834 45.6911 18.834 45.2655 L 18.834 37.4028 C 18.8364 36.9771 18.4932 36.6302 18.0676 36.6278 C 18.0662 36.6278 18.0647 36.6278 18.0633 36.6278 L 9.23622 36.6278 C 8.81049 36.6278 8.46552 36.9729 8.46552 37.3985 L 8.46552 37.4028 L 8.46552 45.2654 C 8.46552 45.6911 8.81049 46.0362 9.23622 46.0362 Z"
            stroke-linecap="round"
          />
        </g>
        <g transform="matrix(1 0 0 1 -24.19 -8.55)" id="path_2">
          <path
            style="
              stroke: none;
              stroke-width: 1;
              stroke-dasharray: none;
              stroke-linecap: butt;
              stroke-dashoffset: 0;
              stroke-linejoin: miter;
              stroke-miterlimit: 4;
              fill: var(--color-text-secondary);
              fill-rule: nonzero;
              opacity: 1;
            "
            transform=" translate(-25.81, -41.33)"
            d="M 21.4004 46.0362 L 30.2275 46.0362 C 30.6532 46.0362 30.9982 45.6911 30.9982 45.2655 L 30.9982 37.4028 C 31.0006 36.9771 30.6574 36.6302 30.2317 36.6278 C 30.2303 36.6278 30.2288 36.6278 30.2274 36.6278 L 21.4003 36.6278 C 20.9722 36.6278 20.6252 36.9747 20.6252 37.4028 L 20.6252 45.2654 C 20.6278 45.6918 20.974 46.0362 21.4004 46.0362 Z"
            stroke-linecap="round"
          />
        </g>
        <g transform="matrix(1 0 0 1 -11.84 -8.55)" id="path_3">
          <path
            style="
              stroke: none;
              stroke-width: 1;
              stroke-dasharray: none;
              stroke-linecap: butt;
              stroke-dashoffset: 0;
              stroke-linejoin: miter;
              stroke-miterlimit: 4;
              fill: var(--color-text-secondary);
              fill-rule: nonzero;
              opacity: 1;
            "
            transform=" translate(-38.16, -41.33)"
            d="M 33.7496 46.0362 L 42.5767 46.0362 C 43.0024 46.0362 43.3474 45.6911 43.3474 45.2655 L 43.3474 37.4028 C 43.3498 36.9771 43.0066 36.6302 42.5809 36.6278 C 42.5795 36.6278 42.5779 36.6278 42.5765 36.6278 L 33.7495 36.6278 C 33.3237 36.6278 32.9788 36.9729 32.9788 37.3985 L 32.9788 37.4028 L 32.9788 45.2654 C 32.9789 45.6911 33.324 46.0362 33.7496 46.0362 Z"
            stroke-linecap="round"
          />
        </g>
        <g transform="matrix(1 0 0 1 0.37 -8.55)" id="path_4">
          <path
            style="
              stroke: none;
              stroke-width: 1;
              stroke-dasharray: none;
              stroke-linecap: butt;
              stroke-dashoffset: 0;
              stroke-linejoin: miter;
              stroke-miterlimit: 4;
              fill: var(--color-text-secondary);
              fill-rule: nonzero;
              opacity: 1;
            "
            transform=" translate(-50.37, -41.33)"
            d="M 45.9525 46.0362 L 54.7796 46.0362 C 55.206 46.0362 55.5523 45.6919 55.5546 45.2655 L 55.5546 37.4028 C 55.5546 36.9747 55.2077 36.6278 54.7796 36.6278 L 45.9525 36.6278 C 45.5268 36.6278 45.1818 36.9729 45.1818 37.3985 L 45.1818 37.4028 L 45.1818 45.2654 C 45.1818 45.6911 45.5269 46.0362 45.9525 46.0362 Z"
            stroke-linecap="round"
          />
        </g>
        <g transform="matrix(1 0 0 1 -24.19 -19.86)" id="path_5">
          <path
            style="
              stroke: none;
              stroke-width: 1;
              stroke-dasharray: none;
              stroke-linecap: butt;
              stroke-dashoffset: 0;
              stroke-linejoin: miter;
              stroke-miterlimit: 4;
              fill: var(--color-text-secondary);
              fill-rule: nonzero;
              opacity: 1;
            "
            transform=" translate(-25.81, -30.02)"
            d="M 21.4004 34.7247 L 30.2275 34.7247 C 30.6538 34.7223 30.9982 34.3759 30.9982 33.9496 L 30.9982 26.0871 C 30.9982 25.6614 30.6531 25.3164 30.2275 25.3164 L 21.4004 25.3164 C 20.9741 25.3164 20.6277 25.6607 20.6254 26.0871 L 20.6254 33.9496 C 20.6277 34.3768 20.9733 34.7223 21.4004 34.7247 Z"
            stroke-linecap="round"
          />
        </g>
        <g transform="matrix(1 0 0 1 -11.84 -19.86)" id="path_6">
          <path
            style="
              stroke: none;
              stroke-width: 1;
              stroke-dasharray: none;
              stroke-linecap: butt;
              stroke-dashoffset: 0;
              stroke-linejoin: miter;
              stroke-miterlimit: 4;
              fill: var(--color-text-secondary);
              fill-rule: nonzero;
              opacity: 1;
            "
            transform=" translate(-38.16, -30.02)"
            d="M 33.7496 34.7247 L 42.5767 34.7247 C 43.0029 34.7223 43.3474 34.3759 43.3474 33.9496 L 43.3474 26.0871 C 43.3474 25.6614 43.0022 25.3164 42.5767 25.3164 L 33.7496 25.3164 C 33.3239 25.3164 32.9789 25.6615 32.9789 26.0871 L 32.9789 33.9496 C 32.9789 34.3759 33.3233 34.7223 33.7496 34.7247 Z"
            stroke-linecap="round"
          />
        </g>
        <g transform="matrix(1 0 0 1 0.37 -19.86)" id="path_7">
          <path
            style="
              stroke: none;
              stroke-width: 1;
              stroke-dasharray: none;
              stroke-linecap: butt;
              stroke-dashoffset: 0;
              stroke-linejoin: miter;
              stroke-miterlimit: 4;
              fill: var(--color-text-secondary);
              fill-rule: nonzero;
              opacity: 1;
            "
            transform=" translate(-50.37, -30.02)"
            d="M 45.9525 34.7247 L 54.7796 34.7247 C 55.2067 34.7223 55.5523 34.3768 55.5546 33.9496 L 55.5546 26.0871 C 55.5523 25.6607 55.206 25.3164 54.7796 25.3164 L 45.9525 25.3164 C 45.5268 25.3164 45.1818 25.6615 45.1818 26.0871 L 45.1818 33.9496 C 45.1818 34.3759 45.5262 34.7223 45.9525 34.7247 Z"
            stroke-linecap="round"
          />
        </g>
        <g transform="matrix(1 0 0 1 0.37 -31.17)" id="path_8">
          <path
            style="
              stroke: none;
              stroke-width: 1;
              stroke-dasharray: none;
              stroke-linecap: butt;
              stroke-dashoffset: 0;
              stroke-linejoin: miter;
              stroke-miterlimit: 4;
              fill: var(--color-text-secondary);
              fill-rule: nonzero;
              opacity: 1;
            "
            transform=" translate(-50.37, -18.7)"
            d="M 45.9525 23.4089 L 54.7796 23.4089 C 55.206 23.4089 55.5523 23.0645 55.5546 22.6382 L 55.5546 14.7712 C 55.5523 14.3448 55.206 14.0005 54.7796 14.0005 L 45.9525 14.0005 C 45.5268 14.0005 45.1818 14.3455 45.1818 14.7712 L 45.1818 22.6381 C 45.1818 23.0638 45.5269 23.4089 45.9525 23.4089 Z"
            stroke-linecap="round"
          />
        </g>
        <g transform="matrix(1 0 0 1 12.68 -8.55)" id="path_9">
          <path
            style="
              stroke: none;
              stroke-width: 1;
              stroke-dasharray: none;
              stroke-linecap: butt;
              stroke-dashoffset: 0;
              stroke-linejoin: miter;
              stroke-miterlimit: 4;
              fill: var(--color-text-secondary);
              fill-rule: nonzero;
              opacity: 1;
            "
            transform=" translate(-62.68, -41.33)"
            d="M 58.2631 46.0362 L 67.0901 46.0362 C 67.5166 46.0362 67.8628 45.6919 67.8652 45.2655 L 67.8652 37.4028 C 67.8652 36.9747 67.5182 36.6278 67.0901 36.6278 L 58.2631 36.6278 C 57.8375 36.6278 57.4924 36.9729 57.4924 37.3985 L 57.4924 37.4028 L 57.4924 45.2654 C 57.4924 45.6911 57.8375 46.0362 58.2631 46.0362 Z"
            stroke-linecap="round"
          />
        </g>
      </g>
    </g>
  </svg>
</template>

<style scoped>
.vue-icon {
  width: 1em;
  height: 1em;
}
</style>
